// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Uy-z","smallCardRow":"Vy-z","largeCardRow":"Wy-z","productSearchRow":"Xy-z","curatedRow":"Yy-z"};